import React from 'react'
import Page from './page'
import './about.css'

function About () {
  return (
    <Page>
      <header className="about-header">
        <h5>Larry Fessenden Presents</h5>
        <h1>Dig Two Graves</h1>
        <p>A mind-bending suspense thriller starring Ted Levine and Samantha Isler.</p>
      </header>
      <section className="about-synopsis">
        <p>DIG TWO GRAVES tells the story of a young girl’s obsession with the death of her brother, taking her on a nightmarish journey where she must a face a deadly proposition to bring him back.</p>
        <p>In her feature film debut, Samantha Isler (CAPTAIN FANTASTIC) gives a heart-wrenching, frightening and physically demanding performance as young Jake Mather, struggling to keep her fractured family together.</p>
        <p>Veteran actor Ted Levine (THE SILENCE OF THE LAMBS) delivers one of the most riveting portrayals of his career as Sheriff Waterhouse, a flawed man torn between good and evil, trying to walk a fine line as a protective grandfather, ruthless sheriff, and accomplice to a murder.</p>
        <p>DIG TWO GRAVES explores emotional truths about grief and loss, while the striking visuals, which are often dark, moody, sexy, and dangerous, create a heightened reality where magic and mysticism can freely exist.</p>
        <p>But this is a cautionary tale, as the title refers to an ancient Chinese proverb, “When you embark on a journey of revenge, dig two graves!”</p>
        <p>DIG TWO GRAVES was shot on location in southern Illinois during one of the coldest winters on record. The film has gone on to win over half a dozen top prizes at festivals across the country. Follow us on Twitter and Facebook for updates.</p>
      </section>
      <section className="about-credits">
        <p>
          Directed by Hunter Adams
          <br />Written by Hunter Adams, Jeremy Phillips
          <br />Produced by P.J. Fishwick, Claire Connelly
          <br />Edited by Scott D. Hanson
          <br />Production Design by Merje Veske
          <br />Costume Design by Lizzie Cook
          <br />Cinematography by Eric “The Swede” Maddison
          <br />Music by Brian Deming, Ryan Kattner, Joe Plummer
          <br />Post-Production Sound by P.K. Hooker, Andrew Duncan, Derek Vanderhorst
          <br />Executive Produced by Larry Fessenden, Kim Sherrell, Neal Schneider
        </p>
      </section>
    </Page>
  )
}

export default About



// WEBPACK FOOTER //
// ./src/components/about.js